module.exports = __webpack_public_path__ + "img/TelegramBM.e646fe2.svg";